import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import classNames from "classnames";
import MediaSwitch from "@default/general-components/media-switch";
import DashedCorners from "@default/general-components/dashed-corners";

const MenuTeaser = () => {
  const mainSettings = useSelector(
    (reduxStore) => reduxStore.appStore.mainSettings
  );

  const teaser = mainSettings?.fieldMenuTeaser;

  if (!teaser) return null;

  const {
    fieldMenuTeaserHeadline,
    fieldMenuTeaserSubline,
    fieldMenuTeaserText,
    fieldMultimediaSingle,
    fieldMenuTeaserLink,
    fieldMainColors,
  } = teaser;

  const HeadlineWrapper = ({ children }) =>
    fieldMenuTeaserLink?.uri?.path ? (
      <Link to={fieldMenuTeaserLink.uri.path} className="headline-wrapper">
        {children}
      </Link>
    ) : (
      <div className="headline-wrapper">{children}</div>
    );

  return (
    <div
      className={classNames("menu-teaser", {
        "has-media": fieldMultimediaSingle,
        "no-media": !fieldMultimediaSingle,
        [`background-${fieldMainColors}`]:
          fieldMainColors && !fieldMultimediaSingle,
      })}
    >
      {fieldMultimediaSingle && (
        <div className="media-wrapper">
          <MediaSwitch
            media={fieldMultimediaSingle}
            item={fieldMultimediaSingle}
            autoplay={true}
            loop={true}
          />
        </div>
      )}
      <div className="content">
        {fieldMenuTeaserHeadline && (
          <HeadlineWrapper>
            <span className="headline headline-m">
              <DashedCorners />
              <span className="scale-on-hover">{fieldMenuTeaserHeadline}</span>
            </span>
          </HeadlineWrapper>
        )}
        {(fieldMenuTeaserSubline || fieldMenuTeaserText) && (
          <div className="teaser-bottom">
            {fieldMenuTeaserSubline && (
              <p className="subline headline-s">{fieldMenuTeaserSubline}</p>
            )}
            {fieldMenuTeaserText && (
              <div
                className="text body-m"
                dangerouslySetInnerHTML={{ __html: fieldMenuTeaserText }}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default MenuTeaser;
